import React from 'react';
import Styles from './create-account-footer-styles.scss';
const CreateAccountFooter = () => {
    return (React.createElement("footer", { className: Styles.footer },
        React.createElement("div", { className: Styles.left },
            React.createElement("span", null, "Copyright"),
            " \u00A9 ",
            new Date().getFullYear(),
            " KidVestors, Inc. All Rights Reserved"),
        React.createElement("div", { className: Styles.right },
            React.createElement("a", { href: "https://www.kidvestors.co/legal", target: "_blank", rel: "noopener noreferrer", className: Styles.link }, "Terms & Conditions"),
            React.createElement("a", { href: "https://www.kidvestors.co/privacypolicy", target: "_blank", rel: "noopener noreferrer", className: Styles.link }, "Privacy Policy"))));
};
export default CreateAccountFooter;
